import { apiService } from '@/services/APIService';

export default {
  getPublicEventStages(params) {
    return apiService.get('/public/event-stages', params);
  },

  getEventStages(params) {
    return apiService.get('/event-stages', params);
  },

  showEventStage(id, params) {
    return apiService.get(`/event-stages/${id}`, params);
  },

  getEventStageMembers(id, params) {
    return apiService.get(`/event-stages/${id}/members`, params);
  },

  updateEventStage(id, params) {
    return apiService.put(`/event-stages/${id}`, params);
  },

  transitionStageTeams(id, params) {
    return apiService.post(`/event-stages/${id}/transfer-teams`, params);
  },

  cancelTranstionStageTeams(id, params) {
    return apiService.delete(`/event-stages/${id}/transfer-teams`, { data: params });
  },

  transitionStageUsers(id, params) {
    return apiService.post(`/event-stages/${id}/transfer-users`, params);
  },

  cancelTranstionStageUsers(id, params) {
    return apiService.delete(`/event-stages/${id}/transfer-users`, { data: params });
  },

  transitionUsersToTargetStage(id, params) {
    return apiService.post(`/event-stages/${id}/transfer-users-to-target-stage`, params);
  },

  transitionTeamsToTargetStage(id, params) {
    return apiService.post(`/event-stages/${id}/transfer-teams-to-target-stage`, params);
  },

  // DOCUMENTS
  getStageDocuments(params) {
    return apiService.get('/event-stage-documents/', params);
  },

  getPublicStageDocuments(params) {
    return apiService.get('/public/event-stage-documents/', params);
  },

  createStageDocument(params) {
    return apiService.post('/event-stage-documents/', params);
  },

  deleteStageDocument(id) {
    return apiService.delete(`/event-stage-documents/${id}`);
  },

  // ACTIVITIES
  getStageActivities(id, params) {
    return apiService.get(`/event-stages/${id}/activities/`, params);
  },
  getPublicStageActivities(id, params) {
    return apiService.get(`/public/event-stages/${id}/activities/`, params);
  },

  getActivity(id, id_activity, params) {
    return apiService.get(`/event-stages/${id}/activities/${id_activity}`, params);
  },

  createStageActivities(id, params) {
    return apiService.post(`/event-stages/${id}/activities/`, params);
  },

  deleteStageActivity(id_stage, id_activity) {
    return apiService.delete(`/event-stages/${id_stage}/activities/${id_activity}`);
  },

  updateStageActivity(id_stage, id_activity, params) {
    return apiService.put(`/event-stages/${id_stage}/activities/${id_activity}`, params);
  },

  attachImages(id_stage, id_activity, params) {
    return apiService.post(`/event-stages/${id_stage}/activities/${id_activity}/attach-images?expand=images`, params);
  },

  deleteImage(id) {
    return apiService.delete(`/images/${id}`);
  },

  // MEMBERS ACTIVITY SUBSCRIBE

  getMembersActivities(params) {
    return apiService.get('/activities', params);
  },

  membersActivity(id, params) {
    return apiService.get(`/activities/${id}`, params);
  },

  membersActivityJoin(id) {
    return apiService.post(`/activities/${id}/join`);
  },

  membersActivityLeave(id) {
    return apiService.post(`/activities/${id}/leave`);
  },

  favoriteActivityAdd(id) {
    return apiService.post(`/activities/${id}/favorite/add`);
  },

  favoriteActivityRemove(id) {
    return apiService.delete(`/activities/${id}/favorite/remove`);
  },

  /**
   * @param {Boolean} value - bool (true|false)
   */
  changeImageMain(id, value) {
    return apiService.post(`/images/${id}/${!value ? 'un' : ''}set-main`);
  },

  attachDocuments(id_stage, id_activity, params) {
    return apiService.post(`/event-stages/${id_stage}/activities/${id_activity}/attach-documents`, params);
  },

  deleteDocument(id) {
    return apiService.delete(`/documents/${id}`);
  },

  updateDocument(id, params) {
    return apiService.put(`/documents/${id}`, params);
  },

  // EXPORT MEMBERS
  exportMembers(id) {
    return apiService.post(`/event-stages/${id}/export-members/`);
  },

  // EXPORT TEAMS
  exportTeams(id, params) { // json: { "type": int }
    return apiService.post(`/event-stages/${id}/teams/export/`, params);
  },
};
